"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createShowResultsAction = createShowResultsAction;
exports.createChangePageAction = createChangePageAction;
exports.createToogleSalesOrganisationGroupingAction = createToogleSalesOrganisationGroupingAction;
exports.createToogleSalesOrganisationFilteringAction = createToogleSalesOrganisationFilteringAction;
exports.createToogleSystemTypeFilteringAction = createToogleSystemTypeFilteringAction;
exports.createToogleSystemTypeGroupingAction = createToogleSystemTypeGroupingAction;
exports.createToogleStatusFilteringAction = createToogleStatusFilteringAction;
exports.createToogleStatusGroupingAction = createToogleStatusGroupingAction;
exports.createToogleDateFilteringAction = createToogleDateFilteringAction;
exports.createToogleDateGroupingAction = createToogleDateGroupingAction;
exports.createToogleUserFilteringAction = createToogleUserFilteringAction;
exports.createToogleUserGroupingAction = createToogleUserGroupingAction;
exports.createToogleDeletedSystemFilteringAction = createToogleDeletedSystemFilteringAction;
exports.createToogleDeletedSystemGroupingAction = createToogleDeletedSystemGroupingAction;
exports.createToogleGenesysNoAction = createToogleGenesysNoAction;
exports.createSelectedSalesOrganisationsAction = createSelectedSalesOrganisationsAction;
exports.createSelectedSystemTypesAction = createSelectedSystemTypesAction;
exports.createSelectedStatusAction = createSelectedStatusAction;
exports.createSelectedDateStartAction = createSelectedDateStartAction;
exports.createSelectedDateEndAction = createSelectedDateEndAction;
exports.createSelectedUsernameAction = createSelectedUsernameAction;
exports.createSelectDeletedSystemsAction = createSelectDeletedSystemsAction;
function createShowResultsAction() {
    return {
        type: "usage-statistics/SHOW_RESULTS"
    };
}
function createChangePageAction(newPageNumber) {
    return {
        type: "usage-statistics/CHANGE_PAGE",
        payload: {
            newPageNumber
        }
    };
}
function createToogleSalesOrganisationGroupingAction() {
    return {
        type: "usage-statistics/TOOGLE_SALES_ORGANISATION_GROUPING"
    };
}
function createToogleSalesOrganisationFilteringAction() {
    return {
        type: "usage-statistics/TOOGLE_SALES_ORGANISATION_FILTERING"
    };
}
function createToogleSystemTypeFilteringAction() {
    return {
        type: "usage-statistics/TOOGLE_SYSTEM_TYPE_FILTERING"
    };
}
function createToogleSystemTypeGroupingAction() {
    return {
        type: "usage-statistics/TOOGLE_SYSTEM_TYPE_GROUPING"
    };
}
function createToogleStatusFilteringAction() {
    return {
        type: "usage-statistics/TOOGLE_STATUS_FILTERING"
    };
}
function createToogleStatusGroupingAction() {
    return {
        type: "usage-statistics/TOOGLE_STATUS_GROUPING"
    };
}
function createToogleDateFilteringAction() {
    return {
        type: "usage-statistics/TOOGLE_DATE_FILTERING"
    };
}
function createToogleDateGroupingAction() {
    return {
        type: "usage-statistics/TOOGLE_DATE_GROUPING"
    };
}
function createToogleUserFilteringAction() {
    return {
        type: "usage-statistics/TOOGLE_USER_FILTERING"
    };
}
function createToogleUserGroupingAction() {
    return {
        type: "usage-statistics/TOOGLE_USER_GROUPING"
    };
}
function createToogleDeletedSystemFilteringAction() {
    return {
        type: "usage-statistics/TOOGLE_DELETED_SYSTEM_FILTERING"
    };
}
function createToogleDeletedSystemGroupingAction() {
    return {
        type: "usage-statistics/TOOGLE_DELETED_SYSTEM_GROUPING"
    };
}
function createToogleGenesysNoAction() {
    return {
        type: "usage-statistics/TOOGLE_GENESYS_NO"
    };
}
function createSelectedSalesOrganisationsAction(ids) {
    return {
        type: "usage-statistics/SELECTED_SALES_ORGANISATIONS",
        payload: ids
    };
}
function createSelectedSystemTypesAction(ids) {
    return {
        type: "usage-statistics/SELECTED_SYSTEM_TYPES",
        payload: ids
    };
}
function createSelectedStatusAction(ids) {
    return {
        type: "usage-statistics/SELECTED_STATUS",
        payload: ids
    };
}
function createSelectedDateStartAction(date) {
    return {
        type: "usage-statistics/SELECTED_DATE_START",
        payload: date
    };
}
function createSelectedDateEndAction(date) {
    return {
        type: "usage-statistics/SELECTED_DATE_END",
        payload: date
    };
}
function createSelectedUsernameAction(username) {
    return {
        type: "usage-statistics/SELECTED_USERNAME",
        payload: username
    };
}
function createSelectDeletedSystemsAction(ids) {
    return {
        type: "usage-statistics/SELECTED_DELETED_SYSTEMS",
        payload: ids
    };
}
//# sourceMappingURL=actions.js.map